import * as React from "react";

const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
  >
    <path
      fill="#EEB63F"
      d="m19.51 7.586-5.454-.793-2.439-4.943a.69.69 0 0 0-1.233 0L7.945 6.793l-5.454.793a.686.686 0 0 0-.38 1.173l3.946 3.848-.932 5.433a.687.687 0 0 0 .996.724l4.88-2.565 4.879 2.565a.686.686 0 0 0 .997-.724l-.933-5.433 3.947-3.848a.7.7 0 0 0 .2-.393.685.685 0 0 0-.58-.78"
    ></path>
  </svg>
);

export default StarIcon;
